import React, { Fragment } from "react";
import "./drawer-slider-item.css";
import { getTaggingFunc } from "../../helpers/dataLayerData";
import useWindowSize from "./../../hooks/useWindowSize";

const ContentSliderItem = (props) => {
  const drawerType = props.drawerType
  const url = props.redirectURL
  const imageUrl = props.imageUrl
  const mobileImageUrl = props.mobileImageUrl
  const imageAlt = props.imageAlt
  const screenStatus = useWindowSize();
  const eventAction = 'Link'
  const desc = props.description
  const pos = props.position
  const type= props.drawerType //normal or slide or landscape
  const eventLabel = `${imageAlt} Position ${pos}`
  var imageUrlValidation
  if(screenStatus === 'mobile'){
    if(mobileImageUrl === '') {
      imageUrlValidation = imageUrl
    }else{
      imageUrlValidation = mobileImageUrl
    }
  }else {
    if(imageUrl === '') {
      imageUrlValidation = mobileImageUrl
    }else{
      imageUrlValidation = imageUrl
    }
  }
  //console.log(imageUrlValidation)
  return (
    <Fragment>
      {imageUrlValidation !== '' ? (<a
        className="slideWrapper text-center text-primary"
        href={url}
        onClick={() => getTaggingFunc(screenStatus, eventAction, eventLabel, drawerType)}
      >
        <img
          className="noSelect slideHero border-graylight lazy"
          src={imageUrlValidation}
          alt={imageAlt}
          loading="lazy"
          style={(type === 'landscape' || type === 'landscapeside') ? {height: '207px', width:'330px'}:null}
        />
        <p className="noSelect catalogueTitle">
          {desc}
        </p>
      </a>) : null}
    </Fragment>
  );
};

export default React.memo(ContentSliderItem);
